(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lookbook-slider')) {
    class LookbookSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.caps = Array.from(this.querySelectorAll('[data-cap]'));
        this.nums = Array.from(this.querySelectorAll('[data-num]'));
        this.fill = this.querySelector('[data-fill]');
        this.count = this.slides.length;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.autoplay = this.dataset.autoplay === 'true' && this.count > 1;
        this.index = 0;
        this.timer = null;

        this.nums.forEach((btn, i) => btn.addEventListener('click', () => this.go(i)));
        this.onVis = () => (document.hidden ? this.stop() : this.go(this.index));
        document.addEventListener('visibilitychange', this.onVis);

        this.go(0);
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVis);
      }

      stop() { clearTimeout(this.timer); }

      go(i) {
        this.stop();
        this.index = (i + this.count) % this.count;

        [this.slides, this.caps, this.nums].forEach((list) =>
          list.forEach((el, n) => el.classList.toggle('is-active', n === this.index))
        );
        this.nums.forEach((el, n) => {
          if (n === this.index) el.setAttribute('aria-current', 'true');
          else el.removeAttribute('aria-current');
        });

        this.progress();
        if (this.autoplay) this.timer = setTimeout(() => this.go(this.index + 1), this.speed);
      }

      /* Line grows as slides advance: 0-25%, 25-50%, 50-75%, 75-100% */
      progress() {
        if (!this.fill) return;
        const from = (this.index / this.count) * 100;
        const to = ((this.index + 1) / this.count) * 100;
        this.fill.style.transition = 'none';
        this.fill.style.width = from + '%';
        void this.fill.offsetWidth; // restart transition
        if (this.autoplay) {
          this.fill.style.transition = 'width ' + this.speed + 'ms linear';
          this.fill.style.width = to + '%';
        } else {
          this.fill.style.width = to + '%';
        }
      }
    }
    customElements.define('lookbook-slider', LookbookSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var pagi = document.querySelector('.AjaxinatePagination');
    if (pagi && typeof Ajaxinate !== 'undefined') {
      // "Next page" dabane par agle 16 products isi page mein neeche add ho jate hain
      new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: 'click'
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Heart ko image ke top-right corner par rakho. Image ab upar se align hai (object-position: top),
     isliye vertical offset hamesha 5px; horizontal offset image ki asal width se nikalta hai */
  function wtPlaceHeart(root) {
    var heart = root.querySelector('.wt-heart');
    var stage = root.querySelector('.wt-stage');
    if (!heart || !stage) return;
    var slide = stage.querySelector('.wt-slide.is-active');
    var img = slide && slide.querySelector('img');
    if (!img || !img.naturalWidth || !stage.clientWidth || !stage.clientHeight) {
      heart.style.top = '';
      heart.style.right = '';
      return;
    }
    var sw = stage.clientWidth, sh = stage.clientHeight;
    var iw = img.naturalWidth, ih = img.naturalHeight;
    var fit = window.getComputedStyle(img).objectFit;
    var scale = fit === 'cover' ? Math.max(sw / iw, sh / ih) : Math.min(sw / iw, sh / ih);
    var rw = Math.min(iw * scale, sw);
    heart.style.top = '5px';
    heart.style.right = Math.max(0, (sw - rw) / 2) + 5 + 'px';
  }
  function wtShow(root, slide) {
    if (!slide) return;
    var idx = slide.getAttribute('data-wt-slide');
    root.querySelectorAll('[data-wt-slide]').forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    root.querySelectorAll('[data-wt-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-wt-thumb') === idx); });
    wtPlaceHeart(root);
  }
  function wtQtyState(box) {
    if (!box) return;
    var input = box.querySelector('input');
    var minus = box.querySelector('[data-wt-minus]');
    if (!input || !minus) return;
    minus.classList.toggle('is-disabled', (parseInt(input.value, 10) || 1) <= 1);
  }
  function wtSyncVariant(root) {
    var sel = root.querySelector('select[name="id"]');
    if (!sel) return;

    var mediaHolder = root.querySelector('[data-wt-variant-media]');
    if (mediaHolder) {
      try {
        var map = JSON.parse(mediaHolder.textContent);
        var mid = map[sel.value];
        if (mid) wtShow(root, root.querySelector('[data-wt-slide][data-media-id="' + mid + '"]'));
      } catch (e) {}
    }

    var stockHolder = root.querySelector('[data-wt-variant-stock]');
    var label = root.querySelector('[data-wt-stock]');
    if (stockHolder && label) {
      try {
        var stock = JSON.parse(stockHolder.textContent);
        var ok = stock[sel.value] !== false;
        label.textContent = ok ? label.getAttribute('data-in') : label.getAttribute('data-out');
        label.classList.toggle('is-out', !ok);
      } catch (e) {}
    }
  }

  /* Theme ka apna (bold) breadcrumb chupa do taake sirf Weston wala dikhe */
  function wtHideThemeBreadcrumb() {
    var mine = document.querySelector('[data-wt-product]');
    if (!mine) return;
    document.querySelectorAll('.breadcrumb, .breadcrumbs, .breadcrumb-wrapper, [class*="breadcrumb"], nav[aria-label="breadcrumb"], nav[aria-label="Breadcrumb"]').forEach(function (el) {
      if (mine.contains(el)) return;
      if (el.contains(mine)) return;
      el.style.display = 'none';
    });
  }

  document.addEventListener('click', function (e) {
    /* Info sections: <details> khud click par open/close karta hai, isliye yahan kuch rokna nahi */
    if (e.target.closest('.wt-info-section > summary')) return;

    var thumb = e.target.closest('[data-wt-thumb]');
    if (thumb) {
      var root = thumb.closest('[data-wt-product]');
      wtShow(root, root.querySelector('[data-wt-slide="' + thumb.getAttribute('data-wt-thumb') + '"]'));
      return;
    }
    var minus = e.target.closest('[data-wt-minus]');
    var plus = e.target.closest('[data-wt-plus]');
    if (minus || plus) {
      var box = e.target.closest('[data-wt-qty]');
      var input = box && box.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = plus ? v + 1 : Math.max(1, v - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      wtQtyState(box);
      return;
    }
    var prev = e.target.closest('[data-wt-prev]');
    var next = e.target.closest('[data-wt-next]');
    if (prev || next) {
      var track = e.target.closest('.wt-related__wrap').querySelector('[data-wt-track]');
      var card = track.querySelector('.wt-card');
      var step = card ? card.getBoundingClientRect().width : 260;
      track.scrollBy({ left: (next ? 1 : -1) * step, behavior: 'smooth' });
    }
  });

  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-wt-qty]');
    if (box) wtQtyState(box);
  });

  document.addEventListener('change', function (e) {
    var qbox = e.target.closest && e.target.closest('[data-wt-qty]');
    if (qbox) { wtQtyState(qbox); return; }
    var root = e.target.closest && e.target.closest('[data-wt-product]');
    if (!root) return;
    setTimeout(function () { wtSyncVariant(root); }, 120);
  });

  /* Image load hone par / screen resize par heart dobara image ke corner par */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('.wt-slide')) {
      var root = t.closest('[data-wt-product]');
      if (root) wtPlaceHeart(root);
    }
  }, true);
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-wt-product]').forEach(wtPlaceHeart);
  });

  function loadRelated() {
    document.querySelectorAll('[data-wt-related]').forEach(function (el) {
      if (el.dataset.loaded || el.querySelector('.wt-related__wrap') || !el.dataset.url) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-wt-related][data-section="' + el.dataset.section + '"]');
        if (fresh && fresh.querySelector('.wt-related__wrap')) el.innerHTML = fresh.innerHTML;
      }).catch(function (err) { console.error(err); });
    });
  }

  function initAll() {
    wtHideThemeBreadcrumb();
    loadRelated();
    document.querySelectorAll('[data-wt-product]').forEach(function (root) {
      wtSyncVariant(root);
      root.querySelectorAll('[data-wt-qty]').forEach(wtQtyState);
      wtPlaceHeart(root);
      setTimeout(function () { wtPlaceHeart(root); }, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-wt-product]').forEach(wtPlaceHeart);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
